import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Home',
      },
    },
    {
      path: '/manage/activity',
      name: 'event-management',
      meta: {
        title: 'Manage Activities',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Home-teacher.vue'),
    },
    {
      path: '/manage/template',
      name: 'template-management',
      meta: {
        title: 'Manage Activity Descriptions',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Template.vue'),
    },
    {
      path: '/manage/blacklist',
      name: 'blacklist-management',
      meta: {
        title: 'Blacklist',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Blacklist.vue'),
    },
    {
      path: '/manage/registrations',
      name: 'previous-order-management',
      meta: {
        title: 'Export Registrations',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Export.vue'),
    },
    {
      path: '/manage/user',
      name: 'user-management',
      meta: {
        title: 'Manage User',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Users-info.vue'),
    },
    {
      path: '/activity/:id',
      name: 'event-info',
      meta: {
        title: 'Activity Details',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Events-info.vue'),
    },
    {
      path: '/mailbox',
      name: 'mailbox',
      meta: {
        title: 'Mailbox',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/Mailbox.vue'),
    },
    {
      path: '/my',
      name: 'my-events',
      meta: {
        title: 'My Activities',
      },
      component: () =>
        import(/* webpackChunkName: "about" */ './views/My-events.vue'),
    },
    {
      /* Not Found */
      path: '*',
      redirect: '/',
    },
  ],
});
